import PropTypes from 'prop-types'
import {
    PayPalOneTimePaymentButton,
    PayLaterOneTimePaymentButton
} from '@paypal/react-paypal-js/sdk-v6'
import {PaymentMethod} from './paypalMethods'
import '../../../styles/paypal.css'

const propTypes = {
    method: PropTypes.string.isRequired,
    amount: PropTypes.shape({
        value: PropTypes.string,
        currencyCode: PropTypes.string
    }).isRequired,
    countryCode: PropTypes.string.isRequired,
    merchantName: PropTypes.string,
    environment: PropTypes.oneOf(['sandbox', 'production']).isRequired,
    googlePayConfig: PropTypes.object,
    applePayConfig: PropTypes.object,
    createOrder: PropTypes.func.isRequired,
    onApprove: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFailure: PropTypes.func.isRequired
}

/**
 * Renders the PayPal-owned button for whichever wallet the buyer picked. These buttons are web
 * components (or, for Google Pay, Google's own button) that PayPal styles and drives itself —
 * a payment can only start from a real click on them, so they cannot be replaced by a button
 * of ours that opens the flow programmatically.
 */
const PaypalWalletSection = ({
    method, amount, countryCode, merchantName, environment,
    googlePayConfig, applePayConfig, createOrder, onApprove, onCancel, onFailure
}) => {
    const handleError = (error) => {
        onFailure(error?.message || 'Sorry, your payment could not be processed. Please try again.')
    }

    switch (method) {
        case PaymentMethod.PAYPAL:
            return (
                <PayPalOneTimePaymentButton
                    createOrder={createOrder}
                    onApprove={(data) => onApprove(data.orderId)}
                    onCancel={onCancel}
                    onError={handleError}
                />
            )

        case PaymentMethod.PAY_LATER:
            return (
                <PayLaterOneTimePaymentButton
                    createOrder={createOrder}
                    onApprove={(data) => onApprove(data.orderId)}
                    onCancel={onCancel}
                    onError={handleError}
                />
            )

        default:
            return null
    }
}

PaypalWalletSection.propTypes = propTypes

export default PaypalWalletSection
